import { API } from '@/api';
import { fetchFileVersion } from '@/utils/files';

export const classes = {
  wrapper: 'px-0 py-0 flex flex-col',
  content: 'flex w-full gap-4 grow overflow-hidden',
  timeline: 'h-full shrink-0 w-[350px]',
  viewerCard:
    'relative flex grow p-0 overflow-hidden rounded-2xl border border-solid border-black/10 bg-[#f5f6f9]/60 shadow-aurora-card dark:border-white/10 dark:bg-white/5',
  floatingHeader: 'absolute top-2 left-2 right-2 z-10',
};

export async function fetchFileData(fileId: number) {
  const [file, fileVersion] = await Promise.all([
    API.Files.fetchFile(fileId),
    fetchFileVersion(fileId),
  ]);
  return { file, fileVersion };
}
